import { MentorshipPlanTopicTransformed } from "../../../mentorship-curriculum/types/mentorship-plan";

type UseTopicProps = {
  subject: string;
  groupMentorTopicsBySubject: Record<string, MentorshipPlanTopicTransformed[]>;
};

const useTopic = ({ subject, groupMentorTopicsBySubject }: UseTopicProps) => {
  const topicsBySubject = groupMentorTopicsBySubject[subject];

  function formatMonths(arr: number[]): string {
    if (!arr.length) return "No months";

    // Use Array.from to convert Set to Array
    const uniqueSorted = Array.from(new Set<number>(arr)).sort((a, b) => a - b);

    if (uniqueSorted.length === 1) {
      return `Month ${uniqueSorted[0]}`;
    }

    const isConsecutive = uniqueSorted.every(
      (val, i, a) => i === 0 || val === a[i - 1] + 1
    );

    if (isConsecutive) {
      return `Month ${uniqueSorted[0]} to Month ${
        uniqueSorted[uniqueSorted.length - 1]
      }`;
    }

    const parts = uniqueSorted.map((m) => `Month ${m}`);
    return `${parts.slice(0, -1).join(", ")} and ${parts.slice(-1)}`;
  }

  const monthsPresent = formatMonths(
    topicsBySubject.map((topic) => topic.month)
  );
  const totalAssignments = topicsBySubject.reduce(
    (acc, topic) => acc + topic.topicAssignmentsLength,
    0
  );
  const totalProjects = topicsBySubject.reduce(
    (acc, topic) => acc + topic.topicProjectsLength,
    0
  );
  const totalResources = topicsBySubject.reduce(
    (acc, topic) => acc + topic.topicResourcesLength,
    0
  );

  const totalStudyMaterial = totalAssignments + totalProjects + totalResources;
  const totalSubTopics = topicsBySubject.length;

  return {
    topicsBySubject,
    monthsPresent,
    totalStudyMaterial,
    totalSubTopics,
  };
};

export default useTopic;
